import React from 'react';
import styled from '@emotion/styled';

const AnswerDiv = styled.div`
color:#fff;

`;
const Info = styled.p`
font-size:18px;

span{
    font-weight:bold;
}
`;
const Price = styled.p`
  font-size: 30px;
  span {
    font-weight: bold;
  }
`;

const Quote = ({ answer }) => {
    if (Object.keys(answer).length === 0) return null;
    return (
      <AnswerDiv>
        <Price>
          El precio es: <span>{answer.PRICE}</span>
        </Price>
        <Info>
          El Precio mas Alto: <span>{answer.HIGHDAY}</span>
        </Info>
        <Info>
          El Precio mas Bajo: <span>{answer.LOWDAY}</span>
        </Info>
        <Info>
          Variacion Las Ultimas 24 horas: <span>{answer.CHANGEPCT24HOUR}</span>
        </Info>
        <Info>
          Última Actualización: <span>{answer.LASTUPDATE}</span>
        </Info>
      </AnswerDiv>
    );
    
}

export default Quote;